/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Fairusefactorstitle3Inputs */

const id_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktor Kunci yang Membenarkan Penggunaan Wajar:`)
};

const ms_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktor Utama yang Menjustifikasikan Penggunaan Adil:`)
};

const da_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøglefaktorer der Berettiger Fair Use:`)
};

const de_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Faktoren, die den fairen Gebrauch rechtfertigen:`)
};

const en_us2_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Factors Justifying Fair Use:`)
};

const es_es2_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factores clave que justifican el uso justo:`)
};

const es_mx2_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factores clave que justifican el uso justo:`)
};

const fil_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pangunahing Salik na Nagbibigay-katwiran sa Patas na Paggamit:`)
};

const fr_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facteurs clés justifiant l'utilisation équitable :`)
};

const it_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattori chiave che giustificano il fair use:`)
};

const hu_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fair use-t igazoló kulcsfontosságú tényezők:`)
};

const nl_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belangrijkste factoren die fair use rechtvaardigen:`)
};

const no_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøkkelfaktorer som rettferdiggjør rimelig bruk:`)
};

const pl_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kluczowe czynniki uzasadniające dozwolony użytek:`)
};

const pt_br2_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatores-chave que justificam o uso justo:`)
};

const pt_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais fatores que justificam o Uso Justo:`)
};

const ro_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factori cheie care justifică utilizarea corectă:`)
};

const fi_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohtuullista käyttöä oikeuttavat keskeiset tekijät:`)
};

const sv_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyckelfaktorer som motiverar skälig användning:`)
};

const vi_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các yếu tố chính biện minh cho sử dụng hợp lý:`)
};

const tr_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanımı Haklı Çıkaran Temel Faktörler:`)
};

const cs_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíčové faktory ospravedlňující spravedlivé použití:`)
};

const bg_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключови фактори, оправдаващи честната употреба:`)
};

const ru_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевые факторы, оправдывающие добросовестное использование:`)
};

const uk_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключові фактори, що виправдовують добросовісне використання:`)
};

const ar_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العوامل الرئيسية التي تبرر الاستخدام العادل:`)
};

const hi_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उचित उपयोग को उचित ठहराने वाले प्रमुख कारक:`)
};

const th_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัจจัยสำคัญที่แสดงให้เห็นถึงการใช้งานโดยชอบ:`)
};

const ja_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースを正当化する主な要因：`)
};

const zh_cn2_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持合理使用的关键因素：`)
};

const zh_hant1_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支援合理使用的關鍵因素：`)
};

const ko_privacy_fairusefactorstitle3 = /** @type {(inputs: Privacy_Fairusefactorstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용을 정당화하는 주요 요소:`)
};

/**
* | output |
* | --- |
* | "Key Factors Justifying Fair Use:" |
*
* @param {Privacy_Fairusefactorstitle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_fairusefactorstitle3 = /** @type {((inputs?: Privacy_Fairusefactorstitle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Fairusefactorstitle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_fairusefactorstitle3(inputs)
	if (locale === "ms") return ms_privacy_fairusefactorstitle3(inputs)
	if (locale === "da") return da_privacy_fairusefactorstitle3(inputs)
	if (locale === "de") return de_privacy_fairusefactorstitle3(inputs)
	if (locale === "en-US") return en_us2_privacy_fairusefactorstitle3(inputs)
	if (locale === "es-ES") return es_es2_privacy_fairusefactorstitle3(inputs)
	if (locale === "es-MX") return es_mx2_privacy_fairusefactorstitle3(inputs)
	if (locale === "fil") return fil_privacy_fairusefactorstitle3(inputs)
	if (locale === "fr") return fr_privacy_fairusefactorstitle3(inputs)
	if (locale === "it") return it_privacy_fairusefactorstitle3(inputs)
	if (locale === "hu") return hu_privacy_fairusefactorstitle3(inputs)
	if (locale === "nl") return nl_privacy_fairusefactorstitle3(inputs)
	if (locale === "no") return no_privacy_fairusefactorstitle3(inputs)
	if (locale === "pl") return pl_privacy_fairusefactorstitle3(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_fairusefactorstitle3(inputs)
	if (locale === "pt") return pt_privacy_fairusefactorstitle3(inputs)
	if (locale === "ro") return ro_privacy_fairusefactorstitle3(inputs)
	if (locale === "fi") return fi_privacy_fairusefactorstitle3(inputs)
	if (locale === "sv") return sv_privacy_fairusefactorstitle3(inputs)
	if (locale === "vi") return vi_privacy_fairusefactorstitle3(inputs)
	if (locale === "tr") return tr_privacy_fairusefactorstitle3(inputs)
	if (locale === "cs") return cs_privacy_fairusefactorstitle3(inputs)
	if (locale === "bg") return bg_privacy_fairusefactorstitle3(inputs)
	if (locale === "ru") return ru_privacy_fairusefactorstitle3(inputs)
	if (locale === "uk") return uk_privacy_fairusefactorstitle3(inputs)
	if (locale === "ar") return ar_privacy_fairusefactorstitle3(inputs)
	if (locale === "hi") return hi_privacy_fairusefactorstitle3(inputs)
	if (locale === "th") return th_privacy_fairusefactorstitle3(inputs)
	if (locale === "ja") return ja_privacy_fairusefactorstitle3(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_fairusefactorstitle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_fairusefactorstitle3(inputs)
	return ko_privacy_fairusefactorstitle3(inputs)
});
export { privacy_fairusefactorstitle3 as "privacy.fairUseFactorsTitle" }